export default "__VITE_ASSET__DBE6G5ON__"